import Title from '../common/Title';
import { Container, FormColumn, IntroText, PageHeader } from './styles';
import ProductAssignmentForm from './Form';

const ProductAssignment = () => {
    return (
        <Container>
            <PageHeader>
                <Title>Asignación de productos</Title>
                <IntroText>
                    Completa cada bloque: elige el producto ( Default: Anuncio Simple ), el contacto, la vigencia y las condiciones de ingreso cuando
                    correspondan
                </IntroText>
            </PageHeader>
            <FormColumn>
                <ProductAssignmentForm />
            </FormColumn>
        </Container>
    );
};

export default ProductAssignment;
